import React, { useState } from "react";
import {
  Row, Col, Accordion, Card, Container
} from "react-bootstrap";
import {
  textAccordion, content, taTitle,
  accordionCard, cardHeader, accordionTitle,
  accordionIcon, accordionBody, accordionIconOpen, panLandingTaTitle,
  panLandingContent, faqButton, faqButtonFoodboom
} from "./style.mod.scss";
import RichText from "components/rich-text";
import { ChevronDown } from "react-bootstrap-icons";
import { trackDropdownClick } from "helpers/analytics";
import locale from "locales";
import { useLocation } from "@reach/router";

const TextAccordion = ({ data }) => {
  const { title, accordion, sectionID, newLayout } = data;
  const [open, setOpen] = useState({});
  const [viewMore, setViewMore] = useState(false);
  const location = useLocation();
  const isFoodboom = location.pathname.includes("foodboom");

  const initialItems = 6;
  const displayAccordion = viewMore ? accordion : accordion.slice(0, initialItems);

  return (
    <div className={`${textAccordion}`} style={{ backgroundColor: data?.bgColor && data.bgColor?.hex }} id={sectionID}>
      <Container>
        <Row>
          <Col style={{ padding: newLayout && "0" }}>
            <p className={`${newLayout ? panLandingTaTitle : taTitle}`}>{title}</p>
            <div className={`${newLayout ? panLandingContent : content}`}>
              <Accordion className="pointer">
                {
                  displayAccordion?.map((_tab, index) => (
                    <Card key={index} className={accordionCard}>
                      <Accordion.Toggle
                        as={Card.Header}
                        eventKey={_tab._key}
                        className={cardHeader}
                        onClick={() => {
                          setOpen(open === _tab._key ? null : _tab._key);
                          trackDropdownClick(open === _tab._key ? "close" : "open", _tab.title);
                        }}
                      >
                        <p className={accordionTitle}>{_tab.title}</p>
                        <span className={`${accordionIcon} ${_tab._key !== open ? "" : accordionIconOpen}`}>
                          <ChevronDown />
                        </span>
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey={_tab._key} >
                        <Card.Body className={accordionBody}>
                          <RichText blocks={_tab.accordionText} />
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  ))
                }
                {
                  accordion.length > initialItems &&
                  <div onClick={() => setViewMore(!viewMore)} className={`${faqButton} ${isFoodboom && faqButtonFoodboom}` }>
                    {viewMore ? locale.pages.panLanding.lessQuestions : locale.pages.panLanding.furtherQuestions}
                  </div>
                }
              </Accordion>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TextAccordion;
